import React, { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { useFormik } from "formik";
import { addLTA } from "common/services/ltas.service";
import LTAForm from "./components/LTAForm";
import {
  buildLTAFormData,
  emptyLTAFormValues,
  ltaValidationSchema,
} from "./components/ltaFormValues";
import { toast } from "react-toastify";

const AddLTA: React.FC<{
  toggle: () => void;
  isModalOpen: boolean;
  fetchData: () => void;
}> = ({ toggle, isModalOpen, fetchData }) => {
  const [loading, setLoading] = useState<boolean>(false);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: emptyLTAFormValues(),
    validationSchema: ltaValidationSchema,
    onSubmit: async (values: any) => {
      setLoading(true);
      try {
        await addLTA(buildLTAFormData(values, { isUpdate: false }));
        fetchData();
        validation.resetForm();
        toggle();
        toast.success("LTA added successfully", {});
      } catch (e: any) {
        toast.error("LTA creation failed", {});
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Modal
      id="showModal"
      size="lg"
      isOpen={isModalOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader className="bg-light p-3" toggle={toggle}>
        Add Long Term Agreement
      </ModalHeader>

      <LTAForm
        validation={validation}
        isUpdate={false}
        loading={loading}
        toggle={toggle}
      />
    </Modal>
  );
};

export default AddLTA;
